export default __webpack_public_path__ + "static/media/ie.74a7b8ee.jpg";